import './instagram_message_base_parser.js.coffee'
Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageMediaParser extends Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    messageJSON.message_type == 'media'

  parse: (messageJSON) ->
    builder = new Models.Builders.InstagramMessageMediaBuilder
    @_doParse(builder, messageJSON)
    attachments = @_getMessage(messageJSON).attachments
    builder.attachments = attachments.map((attachment) ->
      new Models.InstagramMedia(attachment.type, attachment.payload.url, attachment.name)
    )
    builder.build()
